import React from 'react';
import { Star } from 'lucide-react';
export const Testimonials = () => {
  const testimonials = [{
    quote: 'Geldhaus provided the capital I needed to expand my retail business to two new locations in Nairobi. Their team was supportive throughout the process.',
    author: 'Sarah Kimani',
    business: 'Founder, Savanna Styles Boutique',
    image: 'https://images.unsplash.com/photo-1567532939604-b6b5b0db2604?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NXx8YWZyaWNhbiUyMHdvbWFufGVufDB8fDB8fHww&auto=format&fit=crop&w=150&q=80'
  }, {
    quote: 'The Growth Accelerator loan helped us invest in new equipment and hire additional staff. The flexible repayment terms aligned perfectly with our cash flow.',
    author: 'David Ochieng',
    business: 'CEO, Nairobi Tech Solutions',
    image: 'https://images.unsplash.com/photo-1506277886164-e25aa3f4ef7f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8YWZyaWNhbiUyMG1hbnxlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&w=150&q=80'
  }, {
    quote: 'As a first-time entrepreneur, I was nervous about taking a loan. Geldhaus made the process simple and provided valuable guidance for my agricultural business.',
    author: 'Grace Muthoni',
    business: 'Owner, Green Harvest Kenya',
    image: 'https://images.unsplash.com/photo-1543269664-76bc3997d9ea?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTB8fGFmcmljYW4lMjB3b21hbnxlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&w=150&q=80'
  }];
  return <section className="py-16 bg-emerald-50" data-id="element-1156">
      <div className="container" data-id="element-1157">
        <h2 className="section-title text-center" data-id="element-1158">Success Stories</h2>
        <p className="section-subtitle text-center" data-id="element-1159">
          Hear from Kenyan business owners who have partnered with Geldhaus to
          achieve their growth objectives.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-12" data-id="element-1160">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-white p-8 rounded-xl shadow-md" data-id="element-1161">
              <div className="flex mb-4" data-id="element-1162">
                {[...Array(5)].map((_, i) => <Star key={i} size={20} className="text-yellow-400 fill-current" data-id="element-1163" />)}
              </div>
              <p className="text-gray-700 mb-6 italic" data-id="element-1164">"{testimonial.quote}"</p>
              <div className="flex items-center" data-id="element-1165">
                <img src={testimonial.image} alt={testimonial.author} className="w-12 h-12 rounded-full object-cover mr-4" data-id="element-1166" />
                <div data-id="element-1167">
                  <h4 className="font-semibold text-gray-800" data-id="element-1168">
                    {testimonial.author}
                  </h4>
                  <p className="text-gray-600 text-sm" data-id="element-1169">
                    {testimonial.business}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};